"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface RevenueFromOperationsTailoringQuestionsProps {
  onBack?: () => void;
}

const MODEL_OPTIONS = [
  "Revenue - ship and bill",
  "Revenue - operating leases",
  "Revenue - recognized over time - cost plus (Services)",
  "Revenue - recognized over time - time elapsed (Services)",
  "Revenue - recognized over time - cost to cost (Services)",
  "Revenue - recognized at a point in time (Services)",
];

const QUESTIONS: TailoringQuestion[] = [
  {
    id: "rfo-model-selection",
    question: "Which of the following revenue models are present in the entity?",
    type: "checkbox",
    options: MODEL_OPTIONS,
  },
  {
    id: "rfo-sb-1",
    question:
      "Does the entity have a history of issuing material credit notes or do we identify a RoMM related to material reversal of revenue due to credit notes issued in the period after period-end?",
    type: "radio",
    options: ["Yes", "No"],
    condition: {
      questionId: "rfo-model-selection",
      value: "Revenue - ship and bill",
      sourceType: "checkbox",
    },
  },
  {
    id: "rfo-sb-2",
    question:
      "Does the entity have any estimates related to sale of goods that are, or are expected to be material?",
    type: "radio",
    options: ["Yes", "No"],
    condition: {
      questionId: "rfo-model-selection",
      value: "Revenue - ship and bill",
      sourceType: "checkbox",
    },
  },
  {
    id: "rfo-sb-3",
    question: "Does the entity have any material transactions at or near period-end?",
    type: "radio",
    options: ["Yes", "No"],
    condition: {
      questionId: "rfo-model-selection",
      value: "Revenue - ship and bill",
      sourceType: "checkbox",
    },
  },
  {
    id: "rfo-sb-4",
    question:
      "Do the contracts with customers constitute different points of revenue recognition based on recognition criteria (transfer of property in goods or significant risks and rewards related to ownership of goods)?",
    type: "radio",
    options: ["Yes", "No"],
    condition: {
      questionId: "rfo-model-selection",
      value: "Revenue - ship and bill",
      sourceType: "checkbox",
    },
  },
  {
    id: "rfo-sb-5",
    question:
      "In the evaluation of whether the entity is an agent or principal for revenue recognized over time using the cost-plus method, are there indicators for both agent and principal?",
    type: "radio",
    options: ["Yes", "No"],
    condition: {
      questionId: "rfo-model-selection",
      value: "Revenue - ship and bill",
      sourceType: "checkbox",
    },
  },
  {
    id: "rfo-cp-1",
    question:
      "Do the entity's contracts with customers include multiple performance obligations related to revenue recognized over time using cost-plus method?",
    type: "radio",
    options: ["Yes", "No"],
    condition: {
      questionId: "rfo-model-selection",
      value: "Revenue - recognized over time - cost plus (Services)",
      sourceType: "checkbox",
    },
  },
  {
    id: "rfo-cp-2",
    question:
      "Does the entity have any material recharged cost revenue? (Recharged cost revenue relates to third party expenses billed to the customer, eg. out of pocket expenses, reimbursement, disbursement, go-through income, or subcontractor).",
    type: "radio",
    options: ["Yes", "No"],
    condition: {
      questionId: "rfo-model-selection",
      value: "Revenue - recognized over time - cost plus (Services)",
      sourceType: "checkbox",
    },
  },
  {
    id: "rfo-te-1",
    question: "Are material advance payments received as part of the contract?",
    type: "radio",
    options: ["Yes", "No"],
    condition: {
      questionId: "rfo-model-selection",
      value: "Revenue - recognized over time - time elapsed (Services)",
      sourceType: "checkbox",
    },
  },
  {
    id: "rfo-ctc-1",
    question: "Does the entity have contracts that covers a number of assets?",
    type: "radio",
    options: ["Yes", "No"],
    condition: {
      questionId: "rfo-model-selection",
      value: "Revenue - recognized over time - cost to cost (Services)",
      sourceType: "checkbox",
    },
  },
  {
    id: "rfo-ctc-2",
    question:
      "Does the management use an expert for the estimates related to revenue recognition?",
    type: "radio",
    options: ["Yes", "No"],
    condition: {
      questionId: "rfo-model-selection",
      value: "Revenue - recognized over time - cost to cost (Services)",
      sourceType: "checkbox",
    },
  },
];

export default function RevenueFromOperationsTailoringQuestions({
  onBack,
}: RevenueFromOperationsTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Revenue from Operations"
      title="Revenue from Operations - Tailoring Questions"
      description="Select revenue models and answer the related tailoring questions."
      questions={QUESTIONS}
      onBack={onBack}
    />
  );
}
